module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-3.61295c06.png";